<template>
  <v-container>
    <v-layout row wrap class="payment_info">
      <v-flex xs12 align-center v-if="errors.length === 0">
        <v-card flat class="pa-2 mt-2">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm8 md9>
                <img class="logo" id="print-logo" alt="Seair Seaplanes" src="@/assets/logo_white.png" />
                <h1 class="primary--text py-4">
                  Booking {{ form_fields.b_id }} Complete
                </h1>
                <v-flex xs12 sm8 md9 class="btn_bar row">
                  <v-btn @click="printBooking(form_fields.b_id)" class="primary pa-2">
                    <v-icon class="pl-2">print</v-icon>
                    Print Booking
                  </v-btn>
                  <v-btn
                    v-if="this.form_fields.b_id > 0"
                   @click="addToCalendar()" class="primary pa-2">
                   <v-icon class="pl-2">calendar_today</v-icon>
                    Add to My Calendar
                  </v-btn>
                </v-flex>
                <p>
                  Thank you for booking with Seair Seaplanes. You have been emailed a confirmation.<br />
                  Please find below a summary of your reservation.
                </p>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm4 md3 class="pb-3 action_buttons">
                <v-layout row wrap>
                  <v-flex xs12 class="btn_bar">
                    <!-- <v-btn
                      v-if="user.id > 0"
                      @click="editBooking"
                      class="accent pa-2"
                      >
                      Edit Booking
                    </v-btn> -->
                    <v-btn @click="newBookingButton()" class="accent pa-2">
                      New Booking
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <FlightSummary />
              </v-flex>
              <v-flex xs12 class="pt-4 pl-1">
                <h2>Contact Information</h2>
                <div v-html="userContactInfo" />
              </v-flex>
              <v-flex xs12>
                <TermsConditions />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Shared from "@/mixins/Shared";
import FlightSummary from "@/components/pages/FlightSummary.vue";
import TermsConditions from "@/components/pages/TermsConditions.vue";

export default {
  name: "PageComplete",
  mixins: [Shared],
  components: {FlightSummary, TermsConditions},
  computed: {
    userContactInfo() {
      return "Name: " +
        this.user.name_first +
        " " +
        this.user.name_last +
        "<br />" +
        "Phone: " +
        this.user.phone.cell +
        "<br />" +
        "Email: " +
        this.user.email;
    }
  },
	mounted() {
		this.trackPurchase();
	}
};
</script>

<style></style>
